 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];

 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		// chunk prefetching for javascript
 		prefetchChunks.forEach(function(chunkId) {
 			if(installedChunks[chunkId] === undefined) {
 				installedChunks[chunkId] = null;
 				var link = document.createElement('link');

 				if (__webpack_require__.nc) {
 					link.setAttribute("nonce", __webpack_require__.nc);
 				}
 				link.rel = "prefetch";
 				link.as = "script";
 				link.href = jsonpScriptSrc(chunkId);
 				document.head.appendChild(link);
 			}
 		});
 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		15: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		15: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"7cc8238","1":"bc1ebf2","2":"8f4b0f6","3":"cd41878","4":"1629748","5":"dc1a994","6":"d2718a1","7":"f31cb0b","8":"04cf86e","9":"6b10076","10":"4e90ef1","11":"43c1fde","12":"31bcc4a","13":"0951a6f","14":"e260e75","16":"008801e","17":"5405cf9","18":"01a4ae0","19":"d4183c8","20":"1bd03d8","21":"74df182","22":"8e08e5f","23":"18f0300","24":"004d2c2","25":"9df4956","26":"c6ae4fa","27":"1d9228c","28":"076c731","29":"7c24b6d","30":"f62e3fd","31":"da8d246","32":"6c1df51","33":"b6c7ca2","34":"7b489bc","35":"2266291","36":"b5e272b","37":"4044689","38":"de60523","39":"a27e207","40":"5f33e4d","41":"2e08a40","42":"350d929","43":"3e85b22","44":"c8d3143","45":"1521926","46":"a385e52","47":"14b5de3","48":"eabe37b","49":"82c7b2f","50":"7507208","51":"7796fc9","52":"b0d0f54","53":"ff5eb1f","54":"19de1e7","55":"658d8a9","56":"16fea15","57":"881c0b5","58":"9631bcb","59":"e6b4072","60":"67e9ead","61":"96f9360","62":"8f6d4f4","63":"d30db1f","64":"60c643e","65":"20d003f","66":"838e634","67":"ca69dbc","68":"e7fca10","69":"284857c","70":"cc1669b","71":"23d2021","72":"771c507","73":"2ce3925","74":"4db0ca5","75":"dcff1ac","76":"f135342","77":"14bbe11","78":"431d42b","79":"11b43d9","80":"66714c2","81":"8d58fe1","82":"7d50301","83":"31d0a7a","84":"0a6dc71","85":"be30b51","86":"6b58e61","87":"cbf402a","88":"116bb2f","89":"5e53e43","90":"cd65f15","91":"d1b4303","92":"e24091e","93":"9ea7e02","94":"2485d2b","95":"fe6423a","96":"2795b07","97":"7026ef0","98":"35a4de6","99":"7ef026f","100":"43843ff","101":"1b68a4e","102":"ccf1f09","103":"f155e6b","104":"d150fbc","105":"5b1b4f5","106":"d398e30","107":"8135312","108":"afb7340","109":"93209ae","110":"e48e762","111":"e773f73","112":"f4e5fae","113":"c06f05a","114":"d2718a6","115":"c65b774","116":"20ab76e","117":"52b8bcc","118":"9757e5c","119":"847be11","120":"1a2c2b2","121":"a50c9d4","122":"2af9b61","123":"970f409","124":"7904108","125":"426e7f0","126":"9081835","127":"e92475f","128":"443d1b2","129":"7cee059","130":"fab3988","131":"a479b7b","132":"46adc42","133":"5f56fe4","134":"f1b1dbf","135":"90d30d0","136":"7cfe003","137":"37b1fdb","138":"074315b","139":"27a4d43","140":"88f436e","141":"1246880","142":"af9f563","143":"83b3747","144":"e3b0a30","145":"4b31ca0","146":"afd45ff","147":"25e09cb","148":"bba61a3","149":"0ce5767","150":"105e88b","151":"54c49b7","152":"913e3c6","153":"3541192","154":"e4a4a8c","155":"4c9f83a","156":"0af7470","157":"6260cc3","158":"5e6b5a6","159":"bf26a52","160":"880f35c","161":"f67cded","162":"72ba220","163":"364f0ea"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// extract-css-chunks-webpack-plugin CSS loading
 		var supportsPreload = (function() { try { return document.createElement("link").relList.supports("preload"); } catch(e) { return false; }}());
 		var cssChunks = {"34":1,"41":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + {"0":"31d6cfe","1":"31d6cfe","2":"31d6cfe","3":"31d6cfe","4":"31d6cfe","5":"31d6cfe","6":"31d6cfe","7":"31d6cfe","8":"31d6cfe","9":"31d6cfe","10":"31d6cfe","11":"31d6cfe","12":"31d6cfe","13":"31d6cfe","14":"31d6cfe","16":"31d6cfe","17":"31d6cfe","18":"31d6cfe","19":"31d6cfe","20":"31d6cfe","21":"31d6cfe","22":"31d6cfe","23":"31d6cfe","24":"31d6cfe","25":"31d6cfe","26":"31d6cfe","27":"31d6cfe","28":"31d6cfe","29":"31d6cfe","30":"31d6cfe","31":"31d6cfe","32":"31d6cfe","33":"31d6cfe","34":"d9901a2","35":"31d6cfe","36":"31d6cfe","37":"31d6cfe","38":"31d6cfe","39":"31d6cfe","40":"31d6cfe","41":"c1db75a","42":"31d6cfe","43":"31d6cfe","44":"31d6cfe","45":"31d6cfe","46":"31d6cfe","47":"31d6cfe","48":"31d6cfe","49":"31d6cfe","50":"31d6cfe","51":"31d6cfe","52":"31d6cfe","53":"31d6cfe","54":"31d6cfe","55":"31d6cfe","56":"31d6cfe","57":"31d6cfe","58":"31d6cfe","59":"31d6cfe","60":"31d6cfe","61":"31d6cfe","62":"31d6cfe","63":"31d6cfe","64":"31d6cfe","65":"31d6cfe","66":"31d6cfe","67":"31d6cfe","68":"31d6cfe","69":"31d6cfe","70":"31d6cfe","71":"31d6cfe","72":"31d6cfe","73":"31d6cfe","74":"31d6cfe","75":"31d6cfe","76":"31d6cfe","77":"31d6cfe","78":"31d6cfe","79":"31d6cfe","80":"31d6cfe","81":"31d6cfe","82":"31d6cfe","83":"31d6cfe","84":"31d6cfe","85":"31d6cfe","86":"31d6cfe","87":"31d6cfe","88":"31d6cfe","89":"31d6cfe","90":"31d6cfe","91":"31d6cfe","92":"31d6cfe","93":"31d6cfe","94":"31d6cfe","95":"31d6cfe","96":"31d6cfe","97":"31d6cfe","98":"31d6cfe","99":"31d6cfe","100":"31d6cfe","101":"31d6cfe","102":"31d6cfe","103":"31d6cfe","104":"31d6cfe","105":"31d6cfe","106":"31d6cfe","107":"31d6cfe","108":"31d6cfe","109":"31d6cfe","110":"31d6cfe","111":"31d6cfe","112":"31d6cfe","113":"31d6cfe","114":"31d6cfe","115":"31d6cfe","116":"31d6cfe","117":"31d6cfe","118":"31d6cfe","119":"31d6cfe","120":"31d6cfe","121":"31d6cfe","122":"31d6cfe","123":"31d6cfe","124":"31d6cfe","125":"31d6cfe","126":"31d6cfe","127":"31d6cfe","128":"31d6cfe","129":"31d6cfe","130":"31d6cfe","131":"31d6cfe","132":"31d6cfe","133":"31d6cfe","134":"31d6cfe","135":"31d6cfe","136":"31d6cfe","137":"31d6cfe","138":"31d6cfe","139":"31d6cfe","140":"31d6cfe","141":"31d6cfe","142":"31d6cfe","143":"31d6cfe","144":"31d6cfe","145":"31d6cfe","146":"31d6cfe","147":"31d6cfe","148":"31d6cfe","149":"31d6cfe","150":"31d6cfe","151":"31d6cfe","152":"31d6cfe","153":"31d6cfe","154":"31d6cfe","155":"31d6cfe","156":"31d6cfe","157":"31d6cfe","158":"31d6cfe","159":"31d6cfe","160":"31d6cfe","161":"31d6cfe","162":"31d6cfe","163":"31d6cfe"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if((tag.rel === "stylesheet" || tag.rel === "preload") && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = supportsPreload ? "preload": "stylesheet";
 				supportsPreload ? linkTag.as = "style" : linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0]; head.appendChild(linkTag)
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 				if(supportsPreload) {
 					var execLinkTag = document.createElement("link");
 					execLinkTag.href =  __webpack_require__.p + "css/" + {"0":"31d6cfe","1":"31d6cfe","2":"31d6cfe","3":"31d6cfe","4":"31d6cfe","5":"31d6cfe","6":"31d6cfe","7":"31d6cfe","8":"31d6cfe","9":"31d6cfe","10":"31d6cfe","11":"31d6cfe","12":"31d6cfe","13":"31d6cfe","14":"31d6cfe","16":"31d6cfe","17":"31d6cfe","18":"31d6cfe","19":"31d6cfe","20":"31d6cfe","21":"31d6cfe","22":"31d6cfe","23":"31d6cfe","24":"31d6cfe","25":"31d6cfe","26":"31d6cfe","27":"31d6cfe","28":"31d6cfe","29":"31d6cfe","30":"31d6cfe","31":"31d6cfe","32":"31d6cfe","33":"31d6cfe","34":"d9901a2","35":"31d6cfe","36":"31d6cfe","37":"31d6cfe","38":"31d6cfe","39":"31d6cfe","40":"31d6cfe","41":"c1db75a","42":"31d6cfe","43":"31d6cfe","44":"31d6cfe","45":"31d6cfe","46":"31d6cfe","47":"31d6cfe","48":"31d6cfe","49":"31d6cfe","50":"31d6cfe","51":"31d6cfe","52":"31d6cfe","53":"31d6cfe","54":"31d6cfe","55":"31d6cfe","56":"31d6cfe","57":"31d6cfe","58":"31d6cfe","59":"31d6cfe","60":"31d6cfe","61":"31d6cfe","62":"31d6cfe","63":"31d6cfe","64":"31d6cfe","65":"31d6cfe","66":"31d6cfe","67":"31d6cfe","68":"31d6cfe","69":"31d6cfe","70":"31d6cfe","71":"31d6cfe","72":"31d6cfe","73":"31d6cfe","74":"31d6cfe","75":"31d6cfe","76":"31d6cfe","77":"31d6cfe","78":"31d6cfe","79":"31d6cfe","80":"31d6cfe","81":"31d6cfe","82":"31d6cfe","83":"31d6cfe","84":"31d6cfe","85":"31d6cfe","86":"31d6cfe","87":"31d6cfe","88":"31d6cfe","89":"31d6cfe","90":"31d6cfe","91":"31d6cfe","92":"31d6cfe","93":"31d6cfe","94":"31d6cfe","95":"31d6cfe","96":"31d6cfe","97":"31d6cfe","98":"31d6cfe","99":"31d6cfe","100":"31d6cfe","101":"31d6cfe","102":"31d6cfe","103":"31d6cfe","104":"31d6cfe","105":"31d6cfe","106":"31d6cfe","107":"31d6cfe","108":"31d6cfe","109":"31d6cfe","110":"31d6cfe","111":"31d6cfe","112":"31d6cfe","113":"31d6cfe","114":"31d6cfe","115":"31d6cfe","116":"31d6cfe","117":"31d6cfe","118":"31d6cfe","119":"31d6cfe","120":"31d6cfe","121":"31d6cfe","122":"31d6cfe","123":"31d6cfe","124":"31d6cfe","125":"31d6cfe","126":"31d6cfe","127":"31d6cfe","128":"31d6cfe","129":"31d6cfe","130":"31d6cfe","131":"31d6cfe","132":"31d6cfe","133":"31d6cfe","134":"31d6cfe","135":"31d6cfe","136":"31d6cfe","137":"31d6cfe","138":"31d6cfe","139":"31d6cfe","140":"31d6cfe","141":"31d6cfe","142":"31d6cfe","143":"31d6cfe","144":"31d6cfe","145":"31d6cfe","146":"31d6cfe","147":"31d6cfe","148":"31d6cfe","149":"31d6cfe","150":"31d6cfe","151":"31d6cfe","152":"31d6cfe","153":"31d6cfe","154":"31d6cfe","155":"31d6cfe","156":"31d6cfe","157":"31d6cfe","158":"31d6cfe","159":"31d6cfe","160":"31d6cfe","161":"31d6cfe","162":"31d6cfe","163":"31d6cfe"}[chunkId] + ".css";
 					execLinkTag.rel = "stylesheet";
 					execLinkTag.type = "text/css";
 					document.body.appendChild(execLinkTag);
 				}
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-static.ecosia.org/web/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 212);
